export default __webpack_public_path__ + "static/media/close-file.20712107.svg";